import React from 'react';
import './styles.scss';

const UnitInfo = ({ unitData }) => {

    const insertAt = (str, sub, pos) => `${str.slice(0, pos)}${sub}${str.slice(pos)}`;

    const getUnitMappingType = (mappingType) => {
        switch (mappingType) {
            case 'FÖRBUTIK': 
                return {
                    className: 'unit-info__pre-store',
                    heading: 'Förbutik'
                }
            default:
                return {
                    className: '',
                    heading: ''
                }
        }
    };

    return (
        <section className="unit-info">
            <div className="unit-info__content">
                {unitData &&
                    <>
                        <div className="unit-info__col">
                            <h2 className="unit-info__heading">Butiksuppgifter</h2>
                            <table className="unit-info__table">
                                <tbody>
                                    {unitData.BusinessHoursOpen && unitData.BusinessHoursClose &&
                                        <tr>
                                            <th>Öppettider</th>
                                            <td>{insertAt(unitData.BusinessHoursOpen, ':', 2)} - {insertAt(unitData.BusinessHoursClose, ':', 2)}</td>
                                        </tr>
                                    }
                                    {unitData.ChainName &&
                                        <tr>
                                            <th>Kedja</th>
                                            <td>{unitData.ChainName}</td>
                                        </tr>
                                    }
                                    {unitData.ChainCode &&
                                        <tr>
                                            <th>Kedjekod</th>
                                            <td>{unitData.ChainCode}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <th>Enhetstyp</th>
                                        <td>{unitData.TypeName}</td>
                                    </tr>
                                    <tr>
                                        <th>Enhetstyp, kod</th>
                                        <td>{unitData.TypeCode}</td>
                                    </tr>
                                    {unitData.WholesaleName &&
                                        <tr>
                                            <th>Grossist</th>
                                            <td>{unitData.WholesaleName}</td>
                                        </tr>
                                    }
                                    {unitData.WholesaleCode &&
                                        <tr>
                                            <th>Grossist, kod</th>
                                            <td>{unitData.WholesaleCode}</td>
                                        </tr>
                                    }
                                    {unitData.WholesaleCustomerCode && 
                                        <tr>
                                            <th>Kundnr. grossist</th>
                                            <td>{unitData.WholesaleCustomerCode}</td>
                                        </tr>
                                    }
                                    {unitData.GLN &&
                                        <tr>
                                            <th>EDI/Lokaliseringsnumber:</th>
                                            <td>{unitData.GLN}</td>
                                        </tr>
                                    }
                                    {(unitData.Assortment && unitData.Assortment.length > 0) &&
                                        <tr>
                                            <th>Sortiment</th>
                                            <td>
                                                {unitData.Assortment && unitData.Assortment.map((asssort, i) => {
                                                    return (
                                                        <React.Fragment key={`asssort${i}`}>
                                                            {asssort}<br />
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </td>
                                        </tr>
                                    }
                                    {(unitData.UnitMappings && unitData.UnitMappings.length > 0) && unitData.UnitMappings.map((item) => {
                                        return (
                                            <tr key={`unitMapping${item.delfiId}`}>
                                                <th className={getUnitMappingType(item.mappingType).className}>{getUnitMappingType(item.mappingType).heading}</th>
                                                <td>
                                                    {item.accessToUnit &&
                                                        <a href={`/unit/${item.delfiId}`} rel="noopener noreferrer">{item.name}</a>
                                                    }
                                                    {!item.accessToUnit && 
                                                        <>
                                                            <div>{item.name}</div>
                                                            <div><a href="mailto:info@delfi.se">Kontakta oss för att få tillgång till enheten</a></div>
                                                        </>
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    {unitData.Cashier && (unitData.Cashier*1) > 0 &&
                                        <tr>
                                            <th>Antal kassor</th>
                                            <td>{unitData.Cashier}</td>
                                        </tr>
                                    }
                                    {unitData.SelfScanningUnits && (unitData.SelfScanningUnits*1) > 0 &&
                                        <tr>
                                            <th>Antal självscanning</th>
                                            <td>{unitData.SelfScanningUnits}</td>
                                        </tr>
                                    }
                                    {unitData.RetailArea && (unitData.RetailArea*1) > 0 &&
                                        <tr>
                                            <th>Säljyta</th>
                                            <td>{unitData.RetailArea} m²</td>
                                        </tr>
                                    }
                                    {(unitData.OtherInformation && unitData.OtherInformation.length > 0) &&
                                        <tr>
                                            <th>Övrig information</th>
                                            <td>
                                                {unitData.OtherInformation && unitData.OtherInformation.map((info, i) => {
                                                    return (
                                                        <React.Fragment key={`otherinfo${i}`}>
                                                            {info}<br />
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </td>
                                        </tr>
                                    }
                                    <tr>
                                        <th>Senast uppdaterad</th>
                                        <td>{unitData.LastChanged}</td>
                                    </tr>
                                    {unitData.IsDeletedOn &&
                                        <tr>
                                            <th>Borttagen</th>
                                            <td>{unitData.IsDeletedOn}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="unit-info__col">	
                            <h2 className="unit-info__heading">Företagsuppgifter</h2>
                            <table className="unit-info__table unit-info__table--last">
                                <tbody>
                                    <tr>
                                        <th>Delfi-nummer</th>
                                        <td>{unitData.DelfiId}</td>
                                    </tr>
                                    <tr>
                                        <th>Namn</th>
                                        <td>
                                            {unitData.UnitName}
                                            {unitData.UnitSecondaryName !== '' &&
                                                <>
                                                    <br />
                                                    {unitData.UnitSecondaryName}
                                                </>
                                            }
                                        </td>
                                    </tr>
                                    {unitData.LegalName &&
                                        <tr>
                                            <th>Juridiskt namn</th>
                                            <td>{unitData.LegalName}</td>
                                        </tr>
                                    }
                                    {unitData.CorporateIdentityNumber &&
                                        <tr>
                                            <th>Org.nr.</th>
                                            <td>{unitData.CorporateIdentityNumber}</td>
                                        </tr>
                                    }
                                    {unitData.StoreManager &&
                                        <tr>
                                            <th>Kontaktperson</th>
                                            <td>{unitData.StoreManager}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <th>A-region</th>
                                        <td>
                                            {unitData.AregionCode} - {unitData.AregionName}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Besöksadress</th>
                                        <td>
                                            {unitData.VisitingAddress.Address}<br />
                                            {unitData.VisitingAddress.PostalCode} {unitData.VisitingAddress.City}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Postadress</th>
                                        <td>
                                            {unitData.PostalAddress.Address}<br />
                                            {unitData.PostalAddress.PostalCode} {unitData.PostalAddress.City}
                                        </td>
                                    </tr>
                                    {unitData.Telephone &&
                                        <tr>
                                            <th>Telefon</th>
                                            <td>{unitData.Telephone}</td>
                                        </tr>
                                    }
                                    {unitData.Telefax &&
                                        <tr>
                                            <th>Fax</th>
                                            <td>{unitData.Telefax}</td>
                                        </tr>
                                    }
                                    {unitData.Email &&
                                        <tr>
                                            <th>Epost</th>
                                            <td>{unitData.Email}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>    
                    </>
                }
            </div>
        </section>
    );
};

export default UnitInfo;